export const SIDEBAR_COLLAPSED_KEY = 'rhdl.ir.web.sidebar.collapsed.v1';
export const TERMINAL_OPEN_KEY = 'rhdl.ir.web.terminal.open.v1';
export const THEME_KEY = 'rhdl.ir.web.theme.v1';
export const COLLAPSIBLE_PANEL_SELECTOR = '#controlsPanel > section, .subpanel';
